import {Box, Card} from "@mui/material";
import { useState } from "react";

interface ColorSelectorProps {
  colors: string[];
  color?: string;
  onSelect: (color: string) => void;
}

const ColorSelector = (props: ColorSelectorProps): JSX.Element => {
    const { colors, onSelect } = props;
    const [currentColor, setCurrentColor] = useState(props.color);

    const handleOnSelect = (color: string) => {
        onSelect(color);
        setCurrentColor(color);
    }

    return (
        <Box display="flex" alignItems="center" gap="8px">
            {colors.map((color) => (
                <Card
                    key={color}
                    onClick={() => handleOnSelect(color)}
                    sx={{
                        width: '30px',
                        height: '30px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        display: 'inline-block',
                        backgroundColor: color,
                        ...(currentColor === color ? {width: '40px', height: '40px', border: '1.5px solid #fff'} : {})
                    }}
                ></Card>
            ))}
        </Box>
    );
};

export default ColorSelector;
